import apiClient from './apiClient'

export interface SupportedCountryDTO {
  code: string
  name: string
  flag: string
}

export const countryService = {
  getCountries: async (): Promise<SupportedCountryDTO[]> => {
    const response = await apiClient.get('/countries')
    return response.data as SupportedCountryDTO[]
  },
}

export default countryService
